import React from 'react';
import { Link } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { signOut, useSession } from '../lib/auth-client';
import './header.css';

interface HeaderProps {
  gameControls?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({ gameControls }) => {
  const { data: session, isPending } = useSession();
  const posthog = usePostHog();
  const displayName = typeof session?.user?.name === 'string' ? session.user.name.trim() : '';
  const accountLabel = displayName || session?.user?.email || 'Account';
  const isLoggedIn = Boolean(session?.user?.id);
  const handleLogout = () => {
    posthog?.capture('auth_logout', {
      route: window.location.pathname
    });
    void signOut();
  };

  return (
    <header className="app-header">
      <div className="app-header__content">
        <Link to="/" className="app-header__brand" aria-label="Panda Planning Poker home">
          Panda Planning Poker
        </Link>
        <nav className="app-header__nav" aria-label="Primary">
          {gameControls}
          {isLoggedIn ? (
            <>
              <Link
                to="/account"
                className="app-header__link app-header__link--user"
                data-foley-click="glide"
              >
                {accountLabel}
              </Link>
              <button
                type="button"
                onClick={handleLogout}
                className="app-header__link app-header__link--button"
                data-foley-click="tap"
              >
                Log out
              </button>
            </>
          ) : isPending ? (
            <span className="app-header__muted">Loading...</span>
          ) : (
            <Link to="/login" className="app-header__link" data-foley-click="glide">
              Log in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
